import React, { memo, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const initBeforeUnLoad = (showExitPrompt) => {
  window.onbeforeunload = (event) => {
    if (showExitPrompt) {
      const e = event || window.event;
      e.preventDefault();
      if (e) {
        e.returnValue = '';
      }
      return '';
    }
  };
};

const WithExitAlert = ({ children, showExitAlert }) => {
  const { t } = useTranslation();

  useEffect(() => {
    initBeforeUnLoad(showExitAlert);
  }, [showExitAlert]);

  return (
    <>
      <Prompt when={showExitAlert} message={t('leaving_message')} />
      {children}
    </>
  );
};

WithExitAlert.defaultProps = {
  showExitAlert: true,
};

WithExitAlert.propTypes = {
  children: PropTypes.node,
  showExitAlert: PropTypes.bool,
};

export default memo(WithExitAlert);
